import { useQuery } from '@tanstack/react-query';
import { head } from 'es-toolkit';

import { UnauthQueryOptions } from '@/api';

export const usePhotoReviewEvent = () => {
  //* 포토후기 이벤트 진행 여부
  const {
    data: photoReviewEventData,
    isLoading: isPhotoReviewEventProgressingLoading,
  } = useQuery({
    ...UnauthQueryOptions['get:/wello/v2/allows/home-donation-event']({
      query: {
        eventCode: 'PHOTO_REVIEW_1000',
      },
    }),
    select: (data) => head(data.context?.contents ?? []),
    staleTime: 0,
    gcTime: 0,
  });

  const isEventProcess = photoReviewEventData?.inProgress ?? false;

  const checkPossibleEvent = (donationAmount?: number) => {
    if (!isEventProcess) return false;
    if (!donationAmount) return false;

    if (!photoReviewEventData?.eventConditionDto?.minDonationAmount)
      return false;

    return (photoReviewEventData.eventConditionDto.minDonationAmount <= donationAmount);
  };

  return {
    /** 포토후기 이벤트 진행 여부 */
    isEventProcess,
    /** 포토후기 이벤트 참여 가능 여부 반환 */
    checkPossibleEvent,
    isLoading: isPhotoReviewEventProgressingLoading,
  };
};
